<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToFormItem',
	inheritAttrs: false
});
</script>
<template>
	<div class="to-form-item" :class="setClass" @click="emit('click')">
		<div ref="labelEl" class="to-form-label" :style="setLabelStyle">
			<div class="to-form-label-text">
				<slot name="label">{{ props.label }}</slot>
			</div>
		</div>
		<div class="to-form-value">
			<slot></slot>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, computed, inject, onMounted, provide } from 'vue'

import type { Ref } from 'vue'

interface ToFormContext {
	type?: string
	space?: Ref<number | string | ''> | number | string | ''
	spaceX?: Ref<number | string | ''> | number | string | ''
	spaceY?: Ref<number | string | ''> | number | string | ''
	labelWidth?: Ref<string | number | ''> | string | number | ''
	submitPosition?: string
	items: any[]
	valueWidth?: Ref<string | ''> | string | ''
	labelPosition?: Ref<string> | string
}



const emit = defineEmits<{
	(e: 'click'): void
}>()

const props = defineProps<{
	label?: string
	labelTip?: string
	tip?: string
	labelWidth?: number | string
	required?: boolean
	merge?: number | string | null
	link?: boolean
}>()

const labelEl = ref<HTMLElement | null>(null)

provide('ToFormItem', {
	label: props.label,
	required: props.required
})

const ToForm = inject<ToFormContext>('ToForm', {
	items: []
})

const setClass = computed(() => {
	const arr: string[] = []
	if (props.required) arr.push('is-required')
	if (props.link) arr.push('link')
	if (props.merge !== null && props.merge !== undefined) arr.push(`merge-${props.merge}`)
	return arr
})

const setLabelStyle = computed(() => {
	const style: Record<string, string> = {}
	if (ToForm.labelWidth) {
		// 检查是否是响应式引用
		const labelWidth = (ToForm.labelWidth as any).value !== undefined ? (ToForm.labelWidth as any).value : ToForm.labelWidth
		if (labelWidth) {
			style.width = labelWidth + 'em'
		}
	}
	return style
})

onMounted(() => {
	if ((ToForm as any).items) {
		;(ToForm as any).items.push({
			$refs: {
				label: labelEl.value
			}
		})
	}
})
</script>
